var _style, _path, _path2, _path3, _polygon, _polygon2, _polygon3, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSageIt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1280 320",
    style: {
      enableBackground: "new 0 0 1280 320"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, " .st0{fill:#05924A;} .st1{fill:#0970B8;} .st2{fill:#1A8E53;} ")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1060.46,269.13V115.99H974.9V86.8h210.72v29.2h-85.92v153.14H1060.46z M920.84,269.13V86.8h39.25v182.34 H920.84z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M74.98,269.07c-17.59,0-29.54-2.95-35.51-8.77c-5.96-5.8-8.99-16.99-8.99-33.27v-3.42l34.13-7.07v21.57h135.95 v-46.67H82.21c-17.47,0-29.33-2.94-35.24-8.75c-5.91-5.8-8.91-17-8.91-33.28v-20.63c0-16.29,3-27.48,8.9-33.28 c5.92-5.81,17.78-8.76,35.24-8.76h105.86c16.91,0,28.64,2.84,34.87,8.46c6.16,5.57,9.28,15.8,9.28,30.39v2.24l-34.13,8.03v-20.62 H71.84v44.2h118.34c17.59,0,29.53,2.95,35.51,8.76c5.96,5.8,8.99,16.99,8.99,33.26v25.58c0,16.28-3.02,27.47-8.99,33.27 c-5.98,5.82-17.92,8.77-35.51,8.77H74.98z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M493.84,269.07c-14.91,0-25.04-2.37-30.09-7.03c-4.99-4.63-7.52-13.73-7.52-27.06v-80.63 c0-13.2,2.53-22.25,7.53-26.88c5.06-4.67,15.18-7.04,30.09-7.04h110.62c14.8,0,24.91,2.32,30.02,6.89c5.04,4.51,7.6,13.01,7.6,25.26 v2.31l-32.36,5.47v-16.03H489.29v99.61h120.42v-36.62h-60.7V184.3h93.06v50.68c0,13.33-2.54,22.43-7.54,27.06 c-5.05,4.66-15.18,7.03-30.08,7.03H493.84z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "661.66,269.07 661.66,120.42 821.41,120.42 821.41,143.26 695.09,143.26 695.09,180.77 768.66,180.77 768.66,202.9 695.09,202.9 695.09,244.63 823.34,244.63 823.34,269.07 "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "295.61,165.46 302.66,153.05 302.52,152.98 318.51,125 319.79,122.88 344.72,78.99 377.41,135.34 378.26,136.93 381.72,142.88 381.77,142.85 393.45,162.95 371.55,181.23 344.98,135.45 318.76,181.62 "
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "290.3,174.83 313.26,191.29 287.81,236.12 345.73,217.44 354.57,220.26 403.29,235.91 376.53,189.79 398.35,171.4 464.88,286.03 345.75,247.78 227.13,286.05 "
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1229.73,78.26c-12.41,0-22.51-10.1-22.51-22.51s10.1-22.51,22.51-22.51s22.51,10.1,22.51,22.51 S1242.14,78.26,1229.73,78.26z M1229.73,36.35c-10.69,0-19.39,8.7-19.39,19.39s8.7,19.39,19.39,19.39s19.39-8.7,19.39-19.39 S1240.42,36.35,1229.73,36.35z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M1223.78,43.34c1.65-0.34,4-0.52,6.25-0.52c3.48,0,5.72,0.64,7.3,2.06c1.27,1.12,1.98,2.84,1.98,4.79 c0,3.33-2.1,5.54-4.75,6.43v0.11c1.95,0.67,3.11,2.47,3.71,5.09c0.82,3.52,1.42,5.95,1.94,6.92h-3.37 c-0.41-0.71-0.97-2.88-1.68-6.02c-0.75-3.48-2.09-4.79-5.05-4.9h-3.07v10.92h-3.25V43.34z M1227.04,54.82h3.33 c3.48,0,5.69-1.91,5.69-4.79c0-3.25-2.36-4.68-5.8-4.71c-1.57,0-2.69,0.15-3.22,0.3V54.82z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSageIt);
export default __webpack_public_path__ + "static/media/Sage-IT.4c74b7c506cd9dabd4093df5734942d9.svg";
export { ForwardRef as ReactComponent };